import type { Dispatch, RefObject, SetStateAction } from "react";
import { useCallback, useRef, useState } from "react";

interface UseDropdownMeasuredHeightRefResult {
  dropdownRef: RefObject<HTMLDivElement | null>;
  measuredHeight: number | null;
  setMeasuredHeight: Dispatch<SetStateAction<number | null>>;
  onDropdownRef: (node: HTMLDivElement | null) => void;
}

export function useDropdownMeasuredHeightRef(): UseDropdownMeasuredHeightRefResult {
  const [measuredHeight, setMeasuredHeight] = useState<number | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const onDropdownRef = useCallback((node: HTMLDivElement | null) => {
    dropdownRef.current = node;
    if (!node) {
      return;
    }

    const height = node.offsetHeight;
    setMeasuredHeight((previous) => (previous === height ? previous : height));
  }, []);

  return {
    dropdownRef,
    measuredHeight,
    setMeasuredHeight,
    onDropdownRef,
  };
}
